import React, { useState } from 'react';
import './App.css';
import logo from './assets/logo.png';
import beeEmpty from './assets/bee-empty.png';
import beeFull from './assets/bee-full.png';
import telegramIcon from './assets/telegram.svg';

// Данные для квиза
const quizData = [
    {
        question: "Что нужно сделать перед тем, как перевести крипту на чей-то кошелёк?",
        options: [
            "Просто скопировать и вставить адрес",
            "Спросить у менеджера в чате, он точно знает",
            "Проверить первые и последние символы адреса"
        ],
        correctAnswer: 2
    },
    {
        question: "В каком году появился биткоин?",
        options: [
            "2009",
            "1789",
            "2045"
        ],
        correctAnswer: 0
    },
    {
        question: "Какой из этих способов самый безопасный для хранения крипты?",
        options: [
            "Онлайн-кошелёк с автологином",
            "Холодный кошелёк без подключения к сети",
            "Telegram-бот с балансом"
        ],
        correctAnswer: 1
    },
    {
        question: "У кого лучше покупать и обменивать криптовалюту?",
        options: [
            "CRYPTO BEE exchanger",
            "Меняло на вокзале",
            "Сын маминой подруги"
        ],
        correctAnswer: 0
    }
];

// Результаты в зависимости от правильных ответов
const resultText = {
    0: "DAMN! You're a rare find, we NEED each other!",
    1: "DAMN! You're a rare find, we NEED each other!",
    2: "NIIIICE! we have a lot in common!",
    3: "NIIIICE! we have a lot in common!",
    4: "WOW! BEErother thats a MATCH!"
};

// Основной компонент приложения
function App() {
    // Состояния
    const [answers, setAnswers] = useState([-1, -1, -1, -1]);
    const [showResults, setShowResults] = useState(false);
    const [score, setScore] = useState(0);

    // Обработчик выбора ответа
    const handleSelectOption = (questionIndex, optionIndex) => {
        const newAnswers = [...answers];
        newAnswers[questionIndex] = optionIndex;
        setAnswers(newAnswers);
    };

    // Проверка, все ли вопросы отвечены
    const allQuestionsAnswered = answers.every(answer => answer !== -1);

    // Обработчик отправки формы
    const handleSubmit = () => {
        if (allQuestionsAnswered) {
            // Подсчет правильных ответов
            let correctCount = 0;
            answers.forEach((answer, index) => {
                if (answer === quizData[index].correctAnswer) {
                    correctCount++;
                }
            });
            setScore(correctCount);
            setShowResults(true);
        }
    };

    // Вычисление процента правильных ответов
    const scorePercentage = (score / quizData.length) * 100;

    return (
        <div className="app">
            {!showResults ? (
                // Страница с вопросами
                <>
                    <div className="header">
                        <div className="logo">
                            <img src={logo} alt="Crypto Bee Logo" />
                        </div>
                        <h1 className="heading">ARE YOU BEE<br/> ENOUGH?</h1>
                    </div>

                    {/* Карточки с вопросами */}
                    {quizData.map((question, qIndex) => (
                        <div key={qIndex} className="quiz-card">
                            <div className="question-text">{qIndex+1}. {question.question}</div>
                            <div className="option-container">
                                {question.options.map((option, oIndex) => (
                                    <button
                                        key={oIndex}
                                        className={`option-button ${answers[qIndex] === oIndex ? 'selected' : ''}`}
                                        onClick={() => handleSelectOption(qIndex, oIndex)}
                                    >
                                        {option}
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}

                    {/* Кнопка отправки */}
                    <button
                        className={`submit-button ${allQuestionsAnswered ? 'active' : ''}`}
                        onClick={handleSubmit}
                        disabled={!allQuestionsAnswered}
                    >
                        Отправить
                    </button>
                </>
            ) : (
                // Страница с результатами
                <div className="result-container">
                    <div className="header">
                        <div className="logo">
                            <img src={logo} alt="Crypto Bee Logo" />
                        </div>
                        <h1 className="heading">{resultText[score]}</h1>
                    </div>

                    {/* Картинка результата */}
                    <div className="result-image">
                        <img src={beeEmpty} alt="Empty Bee" className="bee-background" />
                        <div
                            className="bee-fill"
                            style={{
                                backgroundImage: `url(${beeFull})`,
                                height: `${scorePercentage}%`
                            }}
                        ></div>
                    </div>

                    {/* Процент правильных ответов */}
                    <div className="result-percent">{scorePercentage}%</div>

                    <div className="join-text">join our crypto-hive</div>

                    {/* Кнопка телеграма */}
                    <a
                        href="https://t.me/+rbWsRLbGYWBkYjk8"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="telegram-button"
                    >
                        <img
                            src={telegramIcon}
                            alt="Telegram icon"
                            style={{ width: '24px', height: '24px' }}
                        />
                        Telegram
                    </a>
                </div>
            )}
        </div>
    );
}

export default App;